export function convertToLocaleString(date: string): string {
  return new Date(date).toLocaleString();
}

export function convertToLocaleDateString(date: string): string {
  return new Date(date).toLocaleDateString();
}

export function convertToLocaleStringFromUTC(date: string): string {
  const d = new Date(date);
  d.setHours(d.getHours() + 2);
  return d.toLocaleString().substring(0, 16);
}
